export default "__VITE_ASSET__DdUE54J3__"